import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export interface CreateIndustryPayload {
  name: string;
  status: number;
}

export interface UpdateIndustryPaylod extends CreateIndustryPayload {}

export const INDUSTRY_QUERY_KEY = ["industries"];
export const VIEW_INDUSTRY_QUERY_KEY = ["view-industries"];

export const industriesService = {
  createIndustry: async (payload: CreateIndustryPayload) => {
    return requestWithRefresh(async () => {
      const response = await api.post("api/industries", payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  showIndustry: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/industries/${id}`, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  updateIndustry: async (id: number, payload: UpdateIndustryPaylod) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(`api/industries/${id}`, payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  toggleStatus: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(
        `api/industries/${id}/toggle-status`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data;
    });
  },

  viewAllIndustries: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/view-industries`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),

  getAllIndustries: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/industries`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
